// extracted by mini-css-extract-plugin
module.exports = {"Button":"copyArticleButton_Button__roM5s"};